module.exports = __webpack_public_path__ + "img/404.7b6f6bcf.svg";